import React from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';

import 'styles/Alert.scss';

const Alert = (props) => {
  const {
    icon,
    type,
    style,
    title,
    children,
    className,
  } = props;

  return (
    <div
      style={style}
      className={cc([
        'Alert',
        {
          'Alert--info': type === 'info',
          'Alert--error': type === 'error',
          'Alert--success': type === 'success',
          'Alert--warning': type === 'warning',
          [className]: className,
        }
      ])}
    >
      {
        title &&
        <div className='Alert__header'>
          <h3 className='Alert__title'>
            {title}
          </h3>

          {
            icon &&
            <span className='Alert__icon material-icons'>
              {icon}
            </span>
          }
        </div>
      }
      {
        children &&
        <div className='Alert__body'>
          {children}
        </div>
      }
    </div>
  );
};

Alert.propTypes = {
  icon: PropTypes.string,
  type: PropTypes.oneOf([
    'info',
    'error',
    'default',
    'success',
    'warning',
  ]).isRequired,
  style: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.element,
  className: PropTypes.string,
};

Alert.defaultProps = {
  type: 'default',
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert.jsx